// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1bd58c10] i.v-icon.mdi.mdi-chevron-down{color:var(--v-orange-btn-base)}.clear-search-form__btn[data-v-1bd58c10]{width:140px;border-radius:35px}.search-form__btn[data-v-1bd58c10]{width:120px;border-radius:35px}.v-sheet.v-card[data-v-1bd58c10]{border-radius:10px}[data-v-1bd58c10] .v-list-item{text-align:left}[data-v-1bd58c10] .theme--light.v-list-item--active{background-color:rgba(238,165,7,.2)}", ""]);
// Exports
module.exports = exports;
